<template>
  <vs-prompt
      color="primary"
      @cancel="cancel"
      @accept="accept"
      @close="close"
      :is-valid="validPassword"
      :active.sync="active"
      :title="$t('Labels.Confirm')"
      :accept-text="$t('Labels.Accept')"
      :cancel-text="$t('Labels.Cancel')"
      >
       <div class="con-exemple-prompt">
          {{$t('Messages.EnterPassword')}}
         <vs-input class="w-full" :placeholder="$t('PasswordLabel')" v-model="password" type="password"/>
       </div>
     </vs-prompt>
</template>

<script>
import {globalPass, globalPassActions} from '@/globalPass'

export default {
  data () {
    return {
      password:''
    }
  },
  computed:{
    validPassword () {
      return (this.password.length > 0)
    },
    active () {
      return globalPass.active
    }
  },
  methods:{
    accept (color) {
      globalPassActions.set(btoa(this.password))
      globalPassActions.send()
      this.password = ''
    },
    close () {
      this.password = ''
      globalPassActions.close()
    },
    cancel () {
      this.password = ''
      globalPassActions.close()
    }
  }
}
</script>